// src/components/Status/StatusCard.jsx
import React, { useContext } from 'react';
import './StatusCard.css';
import { MaterialTypesContext } from '../../context/MaterialTypesContext';
import { formatMaterialSize, formatMeasurement } from '../../materials/materialSize';

const getStatusInfo = (message, messageCode) => {
  const normalizedMessage = String(message || '');
  if ((messageCode >= 10 && messageCode <= 40) || normalizedMessage.includes('ALARM') || normalizedMessage.includes('오류')) return { text: '오류', className: 'status-error' };
  if (messageCode === 2 || normalizedMessage.includes('자동 운전중') || normalizedMessage.includes('자동 운전 중') || normalizedMessage.includes('가동')) return { text: '운전중', className: 'status-operating' };
  if (normalizedMessage.includes('Disconnected')) return { text: '연결 끊김', className: 'status-disconnected' };
  return { text: '대기', className: 'status-idle' };
};

function StatusCard({ machine }) {
	const { resolveMaterialType, resolveMaterialShape = (value, legacy) => legacy || value || '-' } = useContext(MaterialTypesContext);
  const statusInfo = getStatusInfo(machine.message, Number(machine.messageCode));
  const resolvedMaterialShape = resolveMaterialShape(machine.materialShapeCode ?? machine.materialShape, machine.materialShape);
  const materialSizeText = formatMaterialSize(
    machine.materialShapeCode, resolvedMaterialShape, machine.materialWidth, machine.materialHeight,
  );

  return (
    <div className="status-card-row">
      {/* 1. 상태 뱃지 */}
      <div className="cell status-col">
        <span className={`status-badge-label ${statusInfo.className}`}>
          {statusInfo.text}
        </span>
      </div>

      {/* 2. 장비명 (강조 사각형) */}
      <div className="cell machine-col">
        <div className="emphasize-box">{machine.machineName}</div>
      </div>

      {/* 3. 일반 데이터 */}
      <div className="cell job-col">{machine.jobName || '-'}</div>
      <div className="cell material-col">{resolveMaterialType(machine.materialTypeCode ?? machine.materialType, machine.materialType)}</div>

      {/* 4. 소재 모양 (강조 사각형) */}
      <div className="cell shape-col">
        <div className="emphasize-box">{resolvedMaterialShape}</div>
      </div>

      {/* 5. 나머지 일반 데이터 */}
      <div className="cell size-col">
        {materialSizeText} mm
      </div>
      <div className="cell length-col">
        {formatMeasurement(machine.inputLength)} mm
      </div>
      <div className="cell count-col">
        {machine.workNum || 0} / {machine.inputNum || 0}
      </div>
      <div className="cell time-col">
        {String(machine.hour || 0).padStart(2,'0')}h {String(machine.minute || 0).padStart(2,'0')}m
      </div>

      {/* 6. 메시지 (강조 사각형) */}
      <div className="cell message-col">
        <div className={`emphasize-box message-box ${statusInfo.className === 'status-error' ? 'alarm-bg' : ''} ${statusInfo.className === 'status-operating' ? 'running-bg' : ''}`}>
          {machine.message || '수동 대기'}
        </div>
      </div>
    </div>
  );
}

export default StatusCard;